import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateUpdateUserMaxEmployers = {
  updateUserMaxEmployers: { data: null, loading: false, error: null },
};

export const updateUserMaxEmployers = createAsyncThunk('user/updateUserMaxEmployers', async ({ userId, max_employers }, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(
      `${process.env.REACT_APP_SERVER_API}/users/${userId}/max-employers`,
      { max_employers },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUpdateUserMaxEmployers = {
  [updateUserMaxEmployers.pending]: (state) => {
    state.updateUserMaxEmployers.loading = true;
    state.updateUserMaxEmployers.error = null;
  },
  [updateUserMaxEmployers.fulfilled]: (state, action) => {
    state.updateUserMaxEmployers.loading = false;
    state.updateUserMaxEmployers.data = action.payload;
    state.updateUserMaxEmployers.error = null;
  },
  [updateUserMaxEmployers.rejected]: (state, action) => {
    state.updateUserMaxEmployers.loading = false;
    state.updateUserMaxEmployers.error = action.payload;
  },
};
